import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import "./i18n.js";
// MASTER SUPABASE GLOBAL INTEGRATION (1. August 2025)
import { masterSupabase } from './lib/supabase-master.js'
// TOLGEE INTEGRATION (24. August 2025)
import { TolgeeProvider, Tolgee, DevTools, FormatSimple } from '@tolgee/react'

const tolgee = Tolgee()
  .use(FormatSimple())
  .init({
    language: 'de',
    defaultLanguage: 'de',
    fallbackLanguage: 'de',
    // Static empty translations — prevents blocking on server connection
    staticData: {
      de: {},
      en: {}
    }
  })

// Enhanced Root Render - No StrictMode to prevent double theme execution
createRoot(document.getElementById('root')).render(
  <TolgeeProvider tolgee={tolgee} fallback={null}>
    <App />
  </TolgeeProvider>
)
